import { Button, Form, Modal, Row } from "react-bootstrap";
import {  UpdateDanceModalProps } from "../interfaces/Timeline";
import { useState } from "react";

export default function UpdateDanceModal(props: UpdateDanceModalProps) {

  const [validated, setValidated] = useState<boolean>(false);

  const handleSubmit = (event: any) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);

    if (props.newDanceName.length > 0) {
      props.handleClose();
      props.updateDanceByModal();
    }
  };


  return (
    <Modal show={props.show} onHide={props.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Update/Remove dance</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Dance name</Form.Label>
            <Form.Control
              required
              value={props.newDanceName}
              onChange={(e) => props.setNewDanceName(e.target.value)}
              placeholder="Type in dance name"
            />
            <Form.Control.Feedback type="invalid">
              Please choose a non-empty name for this dance.
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="danger"
          onClick={() => {
            props.handleClose();
            props.setShowReassuranceModalDance(true);
          }}
        >
          Remove
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
